import React from "react";
import { Dialog, Drawer, Fab, IconButton, List, ListItem, ListItemIcon, ListItemText, Slide, Toolbar, Typography } from "@material-ui/core";
import FolderIcon from "@material-ui/icons/Folder";
import AddIcon from "@material-ui/icons/Add";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { printAssetCategory } from "../../../entities/AssetCategory";
import { useOfflineAssets } from "../../offline/useOfflineAssets";
import { CreateFolderDialog } from "./Components/CreateFolderDialog";
import { AssetCategoryType, AssetCategoryTypes } from "../../../entities/AssetType";
import { SecondLayerMenu } from "./Components/SecondLayerMenu";

export function AddNewFab() {
	const { onlineMode } = useOfflineAssets();
	const [drawerOpen, setDrawerOpen] = React.useState<boolean>(false);
	const [createFolder, setCreateFolder] = React.useState<"folder" | "series" | null>(null);
	const [selectedAssetType, setSelectedAssetType] = React.useState<AssetCategoryType | null>(null)
	const openDrawer = () => setDrawerOpen(true);
	const closeDrawer = () => setDrawerOpen(false);
	const onCreateFolder = (type: "folder" | "series") => {
		closeDrawer();
		setCreateFolder(type);
	};

    const onAddAsset = (type: AssetCategoryType | null) => {
        closeDrawer();
		setSelectedAssetType(type);
    }

	if (!onlineMode) {
		return null;
	}

	return (
		<>
			<Fab
				color="primary"
				style={{
					position: "absolute",
					bottom: 25,
					right: 25,
					minHeight: 52,
					minWidth: 52,
					borderRadius: "50%",
					padding: 0,
				}}
				onClick={openDrawer}
			>
				<AddIcon />
			</Fab>
			<Drawer anchor="bottom" open={drawerOpen} onClose={closeDrawer}>
				<List>
					<ListItem onClick={() => onCreateFolder("folder")}>
						<ListItemIcon style={{ color: "rgb(143, 143, 143)" }}>
							<FolderIcon />
						</ListItemIcon>
						<ListItemText inset primary="Folder" />
					</ListItem>
					<ListItem onClick={() => onCreateFolder("series")}>
						<ListItemIcon style={{ color: "rgb(118, 39, 187)" }}>
							<LibraryBooksIcon />
						</ListItemIcon>
						<ListItemText inset primary="Series" />
					</ListItem>
					{AssetCategoryTypes.map((asset) => {
						return (
							<ListItem
								key={asset.id}
								onClick={() => onAddAsset(asset)}
							>
								<ListItemText inset primary={printAssetCategory(asset.category)} />
							</ListItem>
						);
					})}
				</List>
			</Drawer>
			{createFolder && <CreateFolderDialog onClose={() => onAddAsset(null)} selectedFolderType={createFolder} />}
			{ selectedAssetType &&
				<Dialog
					fullScreen
					open={true}
					onClose={() => setSelectedAssetType(null)}
					TransitionComponent={(p) => <Slide direction="left" {...p} />}
				>
					<Toolbar style={{ borderBottom: "1px solid rgba(32, 33, 36, .4)" }}>
						<IconButton onClick={() => setSelectedAssetType(null)}>
							<ArrowBackIcon />
						</IconButton>
						<Typography variant="h6">Choose your format</Typography>
					</Toolbar>
					<div style={{ marginTop: "8px", marginBottom: "8px", marginLeft: "16px"}}>
						<SecondLayerMenu onCloseAll={() => onAddAsset(null)} selectedMenuCategoryType={selectedAssetType} />
					</div>
				</Dialog>
			}
		</>
	);
}
